import * as React from 'react';
import { FormContainer } from 'react-hook-form-mui';
import { useSendWebPush } from '../../../sic-lib/api/hooks/useWebPush';
import { WebPushSendRequest } from '../../../sic-lib/api/webPush/types/webPush';
import { webPushMessageFormDefaults } from '../../../sic-lib/defaults';
import { MessagingControls } from './MessagingControls';
import SendWebPushResultDialog from './SendWebPushResultDialog';

export function Messaging() {
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const {
        data: sendWebPushDataResponse,
        mutate: sendWebPushMutation,
        isPending: isSendWebPushLoading,
        isSuccess: isSendWebPushSuccess,
        isError: isSendWebPushError,
    } = useSendWebPush();

    const handleSubmit = (data: WebPushSendRequest) => {
        sendWebPushMutation(data, {
            onSuccess(data, variables, context) {
                handleOpenDialog();
            },
        });
    };

    const handleOpenDialog = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <FormContainer<WebPushSendRequest>
                mode="all"
                defaultValues={webPushMessageFormDefaults}
                onSuccess={handleSubmit}
            >
                <MessagingControls
                    isLoading={isSendWebPushLoading}
                    isSuccess={isSendWebPushSuccess}
                    isError={isSendWebPushError}
                />
            </FormContainer>
            {sendWebPushDataResponse && (
                <SendWebPushResultDialog
                    sendWebPushResult={sendWebPushDataResponse}
                    onCloseHandler={handleOpenDialog}
                    isOpen={isOpen}
                />
            )}
        </>
    );
}
